export default __webpack_public_path__ + "static/media/rocket.fbf41081.png";